import React, { ReactElement } from 'react';
import { SiteDto } from '../../api/ClientApi';
import { Box, Grid2, Typography } from '@mui/material';
import { SiteTypeSR } from '../../common/Types';
import { formatNumber, getAddressFromLoactionInfo, mapsSearchUrl } from '../../common/Extensions';
import './SiteInfoExtended.css';
import { useAppSelector } from '../../hooks/hooks';
import { isEmployeeFinanceManager } from '../../redux/selectors/employeeSelector';

type SiteInfoExtendedProps = {
    site?: SiteDto;
    siteTotalValue?: number;
    totalValueUsed?: number;
    totalValueWrittenOff?: number;
    totalValueSold?: number;
};

export default function SiteInfoExtended(props: SiteInfoExtendedProps): ReactElement {
    const { site, siteTotalValue, totalValueUsed, totalValueWrittenOff, totalValueSold } = props;

    const isFinanceManager = useAppSelector(isEmployeeFinanceManager);

    return (
        <Box sx={{ pl: 3, pt: 2, pr: 2, mb: 5, textAlign: 'start' }}>
            <Grid2 container spacing={0}>
                <Grid2 size={{ xs: 12, md: 8, xl: 9 }}>
                    <Typography variant="body1" className="info-text">
                        Naziv skladišta: <span style={{ fontWeight: 'bold' }}>{site?.name}</span>
                    </Typography>
                    <Typography variant="body1" className="info-text">
                        Tip skladišta:{' '}
                        <span style={{ fontWeight: 'bold' }}>{site?.siteType ? SiteTypeSR[site.siteType] : '/'}</span>
                    </Typography>
                    <Typography variant="body1" className="info-text">
                        Klijent:{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {site?.project?.client?.shortName ?? site?.project?.client?.name ?? '/'}
                        </span>
                    </Typography>
                    <Typography variant="body1" className="info-text">
                        Projekat: <span style={{ fontWeight: 'bold' }}>{site?.project?.name ?? '/'}</span>
                    </Typography>
                    <Typography variant="body1" className="info-text">
                        Adresa:{' '}
                        <a
                            href={mapsSearchUrl(getAddressFromLoactionInfo(site?.locationInfo))}
                            target="_blank"
                            rel="noreferrer"
                            style={{ fontWeight: 'bold', color: 'inherit' }}
                        >
                            {getAddressFromLoactionInfo(site?.locationInfo)}
                        </a>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 4, xl: 3 }}>
                    {isFinanceManager && (
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1" className="info-text">
                                    Vrednost na skladištu:{' '}
                                </Typography>
                                <span style={{ fontWeight: 'bold' }}>
                                    {siteTotalValue ? formatNumber(siteTotalValue) : '/'}
                                </span>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1" className="info-text">
                                    Vrednost ugrađene robe:{' '}
                                </Typography>
                                <span style={{ fontWeight: 'bold' }}>
                                    {totalValueUsed ? formatNumber(totalValueUsed) : '/'}
                                </span>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1" className="info-text">
                                    Vrednost otpisane robe:{' '}
                                </Typography>
                                <span style={{ fontWeight: 'bold' }}>
                                    {totalValueWrittenOff ? formatNumber(totalValueWrittenOff) : '/'}
                                </span>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1" className="info-text">
                                    Vrednost prodate robe:{' '}
                                </Typography>
                                <span style={{ fontWeight: 'bold' }}>
                                    {totalValueSold ? formatNumber(totalValueSold) : '/'}
                                </span>
                            </Box>
                        </>
                    )}
                </Grid2>
            </Grid2>
        </Box>
    );
}
